<template>
    <form class="col-md-8 mx-auto" @submit.prevent="onSubmit">
        <div class="loader" v-if="loading"></div>
        <div v-else>
            <page-title :title="$t('thematicArea.title')" :showTitle="false"></page-title>

            <div class="btn-group" role="group" aria-label="Basic example">
                <button type="button"
                        class="btn btn-primary"
                        @click="backToRegister">
                    <i class="fas fa-th-list"></i> {{ $t('backToList') }}
                </button>
            </div>
            <div class="card row">
                <div class="card-header bg-primary text-white">
                    <div class="card-title h5 m-0">{{ $t('thematicArea.information') }}</div>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="form-group col-6">
                            <label :for="'legalArea' + _uid" class="font-weight-bold required">{{ $t('thematicArea.legalArea') }}</label>
                            <dropdown :load-by-parent-sort="true"
                                      :parent-sort="nomenclature.LegalArea"
                                      v-model="thematicArea.legalAreaId"
                                      :required="true"
                                      :fieldName="$t('thematicArea.legalArea')"></dropdown>
                            <span class="text-danger" v-if="errors.has('legalArea' + _uid)">{{ errors.first('legalArea' + _uid) }}</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-12">
                            <label :for="'name' + _uid" class="font-weight-bold required">{{ $t('thematicArea.name') }}</label>
                            <input type="text"
                                   class="form-control"
                                   :id="'name' + _uid"
                                   :name="'name' + _uid"
                                   v-model="thematicArea.name"
                                   v-validate="'required'"
                                   :data-vv-as="$t('thematicArea.name')" />
                            <span class="text-danger" v-if="errors.has('name' + _uid)">{{ errors.first('name' + _uid) }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card row mt-5">
                <div class="card-header bg-primary text-white">
                    <div class="card-title h5 m-0">{{ $t('otherFields.otherFields') }}</div>
                </div>
                <div class="card-body">
                    <otherFields :otherFields="thematicArea.otherFields"></otherFields>
                </div>
            </div>

            <AuxiliaryRegister ref="auxiliaryRegisterRef"
                               :register-id="AuxiliaryRegisters.Thematic_areas"
                               register-name="ThematicArea"
                               :entry-id="thematicArea.auxRegisterEntityId"></AuxiliaryRegister>

            <div class="text-center mt-2 mb-5">
                <button type="button" class="btn btn-primary btn" @click="onSubmit">
                    <i class="fas fa-save"></i>
                    {{ $t('buttons.save.btnText') }}
                </button>
            </div>
        </div>
    </form>
</template>

<script>
    import Dropdown from '../../../components/dropdown/NomenclatureDropdown';
    import OtherFields from '../../../components/otherFields/OtherFields.vue';
    import { ThematicArea } from '@/models/models';
    import PageTitle from '../../../components/common/PageTitle';
    import { NomenclatureParentBySort, AuxiliaryRegisters } from '@/models/enums';
    import AuxiliaryRegister from '@/components/dynamic/AuxiliaryRegister';

    export default {
        inject: ['$validator'],
        components: {
            Dropdown,
            PageTitle,
            OtherFields,
            AuxiliaryRegister
        },
        data() {
            return {
                nomenclature: NomenclatureParentBySort,
                id: null,
                thematicArea: new ThematicArea(),
                loading: false,
                isSaved: false,
                AuxiliaryRegisters: AuxiliaryRegisters
            }
        },
        methods: {
            onSubmit() {
                this.$validator.validateAll().then(result => {
                    if (result) {
                        this.thematicArea.auxRegisterModel = this.$refs.auxiliaryRegisterRef.getDynamicRegisterModelForSubmit();
                        if (this.id) {
                            this.edit();
                        } else {
                            this.create();
                        }
                    }
                })
            },
            backToRegister() {
                this.$router.push('/registers/thematicAreas');
            },
            create() {
                this.loading = true;
                this.$http.post('/api/thematicArea', this.thematicArea).then(result => {
                    this.loading = false;
                    this.isSaved = true;
                    this.$vs.notify({
                        title: this.$t('notifications.success'),
                        text: this.$t('notifications.successfulSavedData'),
                        position: 'top-center',
                        color: 'success'
                    });
                    this.backToRegister();
                }).catch(error => {
                    this.loading = false;
                    this.$vs.notify({
                        title: this.$t('notifications.error'),
                        text: this.$helpers.errorText(error),
                        position: 'top-center',
                        color: 'danger'
                    });
                });
            },
            edit() {
                this.loading = true;
                this.$http.put('/api/thematicArea', this.thematicArea).then(result => {
                    this.loading = false;
                    this.isSaved = true;
                    this.$vs.notify({
                        title: this.$t('notifications.success'), // TODO:
                        text: this.$t('notifications.successfulSavedData'), // TODO:
                        position: 'top-center',
                        color: 'success'
                    });
                    this.backToRegister();
                }).catch(error => {
                    this.loading = false;
                    this.$vs.notify({
                        title: this.$t('notifications.error'), // TODO:
                        text: this.$helpers.errorText(error), // TODO:
                        position: 'top-center',
                        color: 'danger'
                    });
                });
            },
            loadData() {
                this.loading = true;
                this.$http.get(`/api/thematicArea/${this.id}`).then(result => {
                    this.thematicArea = new ThematicArea(result.data);
                    this.$store.initialModel = _.cloneDeep(this.thematicArea);
                }).catch(error => {
                    this.$vs.notify({
                        title: this.$t('buttons.load.btnText'),
                        text: this.$helpers.errorText(error),
                        color: 'danger',
                        time: this.$store.getters.notificationDuration
                    })
                }).then(() => { this.loading = false; });
            }
        },
        mounted() {
            this.id = this.$route.params.id;
            if (this.id) {
                this.loadData();
            }
            this.$store.initialModel = _.cloneDeep(this.thematicArea);
        },
        beforeRouteLeave(to, from, next) {
            if (!_.isEqual(this.$store.initialModel, this.thematicArea) && !this.isSaved) {
                const answer = window.confirm(this.$t('notifications.leavePage'))
                if (answer) {
                    next()
                } else {
                    next(false)
                }
            } else {
                next()
            }
        },
    }
</script>

<style scoped>
</style>
